import { tagsApi } from "../view/tagsService";

export const editTags = tagsApi.injectEndpoints({
  endpoints: (builder) => ({
    editTags: builder.mutation({
      query: ({ id, ...patchData }) => {
        return {
          url: `/v1/api/tag/${id}/`,
          method: "PATCH",
          body: patchData,
        };
      },
      invalidatesTags: [{ type: "tags", id: "LIST" }],
    }),
  }),
});

export const { useEditTagsMutation } = editTags;
